import { render, staticRenderFns } from "./ItemTemplate.vue?vue&type=template&id=48fa968f&scoped=true&"
import script from "./ItemTemplate.vue?vue&type=script&lang=js&"
export * from "./ItemTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ItemTemplate.vue?vue&type=style&index=0&id=48fa968f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa968f",
  null
  
)

export default component.exports